import { FETCH_STATUS } from '../../types/enums/fetch-status.enum';
import { createSlice } from '@reduxjs/toolkit';
import { RouteParamsType } from '../../types/utils/router-params.type';
import { SET_ROUTE_PARAMS } from '../../redux/constants';
import { ToolkitActionType } from '../../types/utils/toolkit-action.type';
import snackbarUtils from '../../utils/SnackbarUtils';
import { getPotscastLogsList } from './potscast.action';

export interface PotscastState {
  accessToken: string | null;
  potscastLogsList: null | unknown;
  potscastLogsListFetchStatus: FETCH_STATUS;
  potscastLogsListRouteParams: RouteParamsType;
}

export const potscastInitialRouteParams = {
  page: 1,
  limit: 10,
  order: '-obj.id',
  q: '',
};

const INIT_STATE: PotscastState = {
  accessToken: null,
  potscastLogsList: null,
  potscastLogsListFetchStatus: FETCH_STATUS.NULL,
  potscastLogsListRouteParams: potscastInitialRouteParams,
};

const potscastSlice = createSlice({
  name: 'potscast',
  initialState: INIT_STATE,
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setPotscastLogsList: (state, action) => {
      state.potscastLogsList = action.payload;
    },
    setPotscastLogsListFetchStatus: (state, action) => {
      state.potscastLogsListFetchStatus = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(SET_ROUTE_PARAMS, (state, action) => {
      const { payload } = action as ToolkitActionType<{ reducer: string; data: RouteParamsType }>;
      if (payload.reducer === 'potscast') {
        state.potscastLogsListRouteParams = { ...state.potscastLogsListRouteParams, ...payload.data };
      }
    });

    builder.addCase(getPotscastLogsList.pending, state => {
      state.potscastLogsListFetchStatus = FETCH_STATUS.PENDING;
    });
    builder.addCase(getPotscastLogsList.rejected, (state, action) => {
      state.potscastLogsListFetchStatus = FETCH_STATUS.REJECTED;
      state.potscastLogsList = null;
      setTimeout(() => {
        snackbarUtils.error(action.payload as string);
      });
    });
    builder.addCase(getPotscastLogsList.fulfilled, (state, action) => {
      state.potscastLogsListFetchStatus = FETCH_STATUS.FULFILLED;
      state.potscastLogsList = action.payload;
    });
  },
});

export const { setAccessToken, setPotscastLogsListFetchStatus, setPotscastLogsList } = potscastSlice.actions;

export default potscastSlice.reducer;
